export const base_url = "https://backend-telepathy-game.encodework.com"

export var router = {
  //sign-in
  admin_login: "/admin/v1/user/login",
  otp_send: "/otp-send-admin",
  otp_verify: "/otp-verify-admin",

  //Events
  get_events: "/admin/v1/user/get-events",
  edit_nov: "/admin/v1/user/set-no-of-virtual-user",
  get_auto_user_join: "/admin/v1/user/get-auto-user-join",
  set_auto_user_join: "/admin/v1/user/set-auto-user-join",

  //Virtual User
  get_v_users: "/admin/v1/user/get-virtual-users",
  add_v_users: "/admin/v1/user/add-user",
  edit_users: "/admin/v1/user/edit-user",
  delete_users: "/admin/v1/user/delete-user",
  change_user_status: "/admin/v1/user/change-user-status",

  //Virtual User
  search_users: "/admin/v1/user/search-user",
  send_notify_to_users: "/admin/v1/user/send-notification",
  


  //Leaderboard User
  leaderboard_get_users: "/admin/v1/user/leaderboard-get-users",
  leaderboard_add_users: "/admin/v1/user/leaderboard-add-user",
  leaderboard_edit_users: "/admin/v1/user/leaderboard-edit-user",
  leaderboard_delete_users: "/admin/v1/user/leaderboard-delete-user",

  //download-user
  download_user_data: "/admin/v1/user/download-user-data",

  //Get Countries
  get_countries: "/api/v1/user/get-countries",

  //Dashboard
  dashboard_leading_data: "/admin/v1/user/dashboard-leading-esp",
  dashboard_user_test: "/admin/v1/user/dashboard-user-test",
  dashboard_country_avg: "/admin/v1/user/dashboard-by-country-average",
  dashboard_crowd_avg_high: "/admin/v1/user/dashboard-crowd-average-highest",
  dashboard_practice_avg_high:
    "/admin/v1/user/dashboard-practice-average-highest",
  dashboard_by_img_hit: "/admin/v1/user/dashboard-by-image-hit",
  dashboard_extra_average_highest:
    "/admin/v1/user/dashboard-extra-average-highest",
  dashboard_user_test_avg: "/admin/v1/user/dashboard-user-test-average",
}
